module.exports = __webpack_public_path__ + "media/sessions/conference@3x-66b69014.png";